import LoginPage from "../pages/LoginPage";
import ResetPasswordForm from "../pages/patients/ResetPasswordPage";
import ForgotPasswordPage from "../pages/patients/ForgotPasswordPage";
import AdminDashboard from "../pages/dashboards/AdminDashboard";
import RequireAuth from "../components/RequireAuth";
import { sharedSecretaryRoutes } from "../routes/sharedSecretaryRoutes"; // 👈 spécifique

export const secretaryRoutes = (onLoginSuccess: (token: string) => void) => [
  {
    path: "/secretary/login",
    element: <LoginPage onLoginSuccess={onLoginSuccess} />,
  },
  { path: "/secretary/resetpassword", element: <ResetPasswordForm /> },
  { path: "/secretary/forgot-password", element: <ForgotPasswordPage /> },
  {
    path: "/secretary/dashboard",
    element: (
      <RequireAuth>
        <AdminDashboard /> {/* Réutilise l'UI dashboard */}
      </RequireAuth>
    ),
    children: sharedSecretaryRoutes, // ✅ Utilise routes séparées
  },
];
